import { render, staticRenderFns } from "./TownHallInbox.vue?vue&type=template&id=0e60fdfc&scoped=true&"
import script from "./TownHallInbox.vue?vue&type=script&lang=js&"
export * from "./TownHallInbox.vue?vue&type=script&lang=js&"
import style0 from "./TownHallInbox.vue?vue&type=style&index=0&id=0e60fdfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60fdfc",
  null
  
)

export default component.exports